import { useDispatch } from 'react-redux';

import { removeLocale } from 'api/TemplateIndexAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useLocalesQueryContext } from 'modules/campaigns/lib/contexts/LocalesQueryContext';

import { useQueryParamContext } from '../context/QueryParamContext';
import { useErrorValidationContext } from '../context/ErrorValidationContext';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';

export const useDeleteLocale = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { removeValidation } = useErrorValidationContext();
  const { setLocale } = useQueryParamContext();
  const { templateDefaultLocale, refetch: refetchLocalesForLocaleSwitcher } =
    useLocalesQueryContext();

  const dispatch = useDispatch();
  const defaultLocaleTag = templateDefaultLocale?.tag || '';

  const deleteLocale = async (localeTag: string) => {
    if (defaultLocaleTag === localeTag || localeTag === '') return;

    try {
      const result = await removeLocale(liveTemplate.templateId, localeTag);
      if (result) {
        dispatch(addPositiveToast(`${localeTag} version removed successfully`));
        removeValidation(localeTag);
        setLocale(defaultLocaleTag);
        refetchLocalesForLocaleSwitcher();
      }
    } catch (error) {
      dispatch(addNegativeToast(`Unable to remove locale, please try again`));
    }
  };
  return deleteLocale;
};
